<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

	interface ToolbarButtonProps {
		onclick: () => void
		title: string
		disabled?: boolean
		active?: boolean
		icon?: IconName
		text?: string
		class?: string
	}

	let {
		onclick,
		title,
		disabled = false,
		active = false,
		icon,
		text,
		class: className = ''
	}: ToolbarButtonProps = $props()

	const isTextButton = !!text && !icon
</script>

<button
	type="button"
	class="toolbar-btn {className}"
	class:active
	class:text-btn={isTextButton}
	{onclick}
	{title}
	{disabled}
>
	{#if icon}
		<Icon name={icon} size="sm" />
	{:else if text}
		{text}
	{/if}
</button>

<style>
	.toolbar-btn {
		@apply flex items-center justify-center w-8 h-8 rounded transition-all text-[#002C4D80] text-sm font-semibold;
	}
	.toolbar-btn:not(:disabled):hover {
		@apply bg-gray-200;
	}
	.toolbar-btn.active {
		@apply bg-brand/10 text-brand;
	}
	.toolbar-btn:disabled {
		@apply opacity-50 cursor-not-allowed pointer-events-none;
	}
	.toolbar-btn.text-btn {
		@apply w-auto px-2;
	}
</style>
